<h3 mat-dialog-title>{{ dialogTitle }}</h3>

<mat-dialog-content class="wp">
    <div *ngFor="let message of dialogMessages">
        {{ message }}
    </div>
</mat-dialog-content>

<mat-dialog-actions [ngClass]="{ 'one-action': isCancelButtonHidden }">
    <button mat-flat-button *ngIf="!isCancelButtonHidden" [ngClass]="cancelButton.class ?? ''" [color]="cancelButton.color" [mat-dialog-close]="false">
        {{ cancelButton.label }}
    </button>

    <button #confirm mat-flat-button [ngClass]="confirmButton.class ?? ''" [color]="confirmButton.color" [mat-dialog-close]="true">
        {{ confirmButton.label }}
    </button>
</mat-dialog-actions>
